module.exports = __webpack_public_path__ + "media/images/Warm-Abstract-4-61b8b776e84c2efd1ed36e7e4ecd10b3.png";